export default function addAccordion() {
  const accordionHeaders = document.querySelectorAll(
    '.c-accordion-item__header',
  )

  function initAccordion() {
    function openAccordion() {
      const parent = this.parentElement
      const article = this.nextElementSibling

      if (!parent.classList.contains('open')) {
        parent.classList.add('open')
        article.style.maxHeight = `100%`
      } else {
        parent.classList.remove('open')
        article.style.maxHeight = '0px'
      }
    }

    for (let i = 0; i < accordionHeaders.length; i++) {
      accordionHeaders[i].addEventListener('click', openAccordion)
    }
  }

  const isPresent = document.getElementsByClassName('c-accordion-wrap')
  if (isPresent.length > 0) {
    initAccordion()

    // open accordion on page refresh
    for (let i = 0; i < accordionHeaders.length; i++) {
      accordionHeaders[i].click()
    }
  }
}
